export default {
   cart: '/api/store/cart',
   checkout: '/api/store/checkout',
   product: '/api/store/product',
   wishlist: '/api/store/wishlist',
   addressfinder: '/api/AddressFinderApi',
}
